<template>
  <div class="filter-box rounded-lg pa-5 mb-6">
    <!-- HEADER -->
    <h3 class="primary--text mb-3">
      <v-icon class="ml-1">mdi-filter</v-icon>
      الفلاتر
    </h3>

    <v-row align="center">
      <!-- QUERY -->
      <v-col class="d-flex" cols="12">
        <v-text-field
          filled
          hide-details
          clearable
          label="كلمة مفتاحية"
          append-icon="mdi-magnify"
          v-model="filters.q"
        ></v-text-field>
      </v-col>

      <!-- SEARCH BUTTON -->
      <v-col class="d-flex pb-1" cols="12">
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="mr-2"
          @click="$router.replace({ query: { ...filters, page: 1 } })"
          color="primary"
        >بحث</v-btn>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'filters-box',


  data: function () {
    return {
      filters: {}
    }
  },

  watch: {
    '$route': {
      handler(route) {
        if (route.query.q) this.filters.q = route.query.q;
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>
